/**
 * SearchWordDetailPresenter
 * --
 */
import { useState, useMemo } from 'react';
import { Content, Title, Row, Col } from 'components';
import moment from 'moment';
import {
  FindSearchWord,
  SearchedSearchWordList,
  SelectedSearchWordList,
  ProductList,
} from './components';
import { handleSearchKeyword } from 'utils/SearchKeyword';
import { styles } from './styles';
const SearchWordDetailPresenter = ({ searchKeywordList, productList }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [search, setSearch] = useState(null);
  const [selectedWord, setSelectedWord] = useState([]);
  /* ===== VARIABLE ===== */

  const products = useMemo(() => {
    if (!selectedWord.length) {
      return productList;
    }

    const newList = new Map(
      selectedWord.flatMap((word) => {
        const findProduct = handleSearchKeyword(
          productList,
          word.search_word,
          'product_name'
        );
        return findProduct.map((product) => [product.product_id, product]);
      })
    ).values();
    return [...newList];
  }, [selectedWord]);

  const handleChangeSelectedList = (word) => {
    setSelectedWord(word);
  };

  const filteredWordList = () => {
    let words = searchKeywordList;
    if (!search) {
      return words;
    }

    if (search.is_visible) {
      words = words.filter((word) => {
        if (search.is_visible === 'visible') {
          if (word.is_show === 'Y') {
            return true;
          }

          return false;
        } else if (search.is_visible === 'in_visible') {
          if (word.is_show === 'N') {
            return true;
          }

          return false;
        }

        return true;
      });
    }

    if (search.search_word) {
      words = words.filter((word) => {
        if (word.search_word.includes(search.search_word)) {
          return true;
        }

        return false;
      });
    }

    if (search.dates) {
      const [from, to] = search.dates;

      if (!from && !to) return words;
      // if(from)
      const mFrom = moment(from, 'YYYY-MM-DD');
      const mTo = moment(to, 'YYYY-MM-DD');

      words = words.filter((word) => {
        const date = moment.unix(word.created_at);
        if (!from) {
          return date.isSameOrBefore(mTo);
        } else if (date.isBetween(mFrom, mTo, 'day', [])) {
          return true;
        }

        return false;
      });
    }
    return words;
  };

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  const state = ['판매중', '판매중지', '심사중', '반려'];
  // for (let i = 0; i < 10; i++) {
  //   newData.push({
  //     상품번호: '000000',
  //     카테고리: '커피/원두',
  //     상품명: '[과테말라] 디카페인 200g',
  //     상태: state[Math.floor(Math.random() * 4)],
  //     판매가: 20000,
  //     할인가: 18000,
  //     수량: 57400,
  //     이미지: <Avatar size={32} shape="square" />,
  //     판매처: 'JM커피',
  //   });
  // }
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>추천검색어 상세정보</Title>

          {/* 검색필터 */}
          <FindSearchWord onChange={setSearch} />
          {/* 검색필터 끝 */}

          {/* 검색된 추천 검색어 */}
          <SearchedSearchWordList
            filteredWordList={filteredWordList()}
            selectedSearchWordList={selectedWord}
            onChangeSelectedList={handleChangeSelectedList}
          />
          {/* 검색된 추천 검색어 끝 */}

          {/* 선택된 추천 검색어 */}
          <SelectedSearchWordList selectedTagList={selectedWord} />
          {/* 선택된 추천 검색어 끝 */}

          {/* 검색결과 */}
          <ProductList productList={products} />
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default SearchWordDetailPresenter;
